import { Box, colors } from "@procore/core-react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

import { trackLinkClicked } from "../telemetry";

/**
 * Wistia 1080p MP4 delivery for hashed id `asxldlo31o`.
 * The iframe embed is blocked under COEP `require-corp`; native video with CORS works.
 */
export const GUIDANCE_VIDEO_URL =
    "https://embed-ssl.wistia.com/deliveries/366a753a67fcd46561703be686f38a1907b9eab5.bin";

export const GUIDANCE_VIDEO_CAPTIONS_URL = "https://fast.wistia.com/embed/captions/asxldlo31o.vtt?language=eng";

export function GuidanceVideo() {
    const { t } = useTranslation();
    const playedRef = useRef(false);

    if (!GUIDANCE_VIDEO_URL) {
        return null;
    }

    return (
        <Box>
            <video
                controls
                crossOrigin="anonymous"
                src={GUIDANCE_VIDEO_URL}
                title={t("gpuGuidance.video.title")}
                data-testid="gpu-guidance-video"
                onPlay={() => {
                    if (!playedRef.current) {
                        playedRef.current = true;
                        trackLinkClicked("video");
                    }
                }}
                style={{
                    width: "100%",
                    aspectRatio: "16 / 9",
                    borderRadius: 4,
                    background: colors.gray10,
                    objectFit: "cover",
                    display: "block",
                }}
            >
                <track kind="captions" src={GUIDANCE_VIDEO_CAPTIONS_URL} srcLang="en" label="English" default />
            </video>
        </Box>
    );
}
